import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/assets/scss/style.scss'
import Autocomplete from '@trevoreyre/autocomplete-vue'
import '@trevoreyre/autocomplete-vue/dist/style.css'
import * as VueGoogleMaps from 'vue2-google-maps'
import VueMask from 'v-mask'
import vSelect from 'vue-select'

import '@/filters'
import '@/directives'
import './assets/tailwind.css'
import {actionType} from './store/modules/auth'

//Arcgis javascript api
import {loadScript} from 'esri-loader'

Vue.config.productionTip = false

// Vue.use(theme)

// preload the ArcGIS API
const options = {
  url: 'https://js.arcgis.com/4.29/',
  parseOnLoad: true,
}

loadScript(options)

Vue.use(Autocomplete)

Vue.use(VueMask)

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyC9JLK_RIcdaYMNqUdSa8mWaxyl3yLXNhc',
    libraries: 'places,drawing',
    region: 'UK',
    language: 'uk',
  },
})
Vue.component('v-select', vSelect)

function createApp() {
  return new Vue({
    router,
    store,
    render: (h) => h(App),
  }).$mount('#app')
}

export default store
  .dispatch(actionType.getCurrentUser)
  .then(createApp)
  .catch(createApp)
